const InformationIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6592 13.3137V15.3137"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M13.1592 9.31372C13.1592 9.58986 12.9353 9.81372 12.6592 9.81372C12.383 9.81372 12.1592 9.58986 12.1592 9.31372C12.1592 9.03758 12.383 8.81372 12.6592 8.81372C12.9353 8.81372 13.1592 9.03758 13.1592 9.31372Z"
        stroke="currentColor"
      />
      <path
        d="M19.9092 12.3137C19.9092 16.3178 16.6632 19.5637 12.6592 19.5637C8.65512 19.5637 5.40918 16.3178 5.40918 12.3137C5.40918 8.30966 8.65512 5.06372 12.6592 5.06372C16.6632 5.06372 19.9092 8.30966 19.9092 12.3137Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default InformationIcon
